import React from 'react';
import {Box, Stack, Typography} from '@mui/material';

/**
 * Shared hashtag info content used by both popover and floating menu node-info mode.
 */
export default function HashtagInfoCard({tagData, sx = {}}) {
    if (!tagData) return null;

    return (
        <Box sx={{p: 2, minWidth: 250, maxWidth: 350, ...sx}}>
            <Stack spacing={1.5}>
                <Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            color: 'rgba(156, 39, 176, 1)',
                        }}
                    >
                        #{tagData.label}
                    </Typography>
                </Box>

                <Box sx={{pt: 1, borderTop: 1, borderColor: 'divider'}}>
                    <Typography variant="body2" color="text.secondary">
                        Tag information and related content will appear here.
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
}

